import produce, { castDraft, } from 'immer';
import { UsersActionType, } from './actions';
const usersByIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case UsersActionType.SET_USERS:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const { usersDataSet } = actualAction;
                usersDataSet.items.forEach((user) => {
                    draft[user.id] = user;
                });
            });
        case UsersActionType.SET_USER:
            // When a user profile is updated, we need to update the associated user in the map of users by id
            return produce(currentState, (draft) => {
                const actualAction = action;
                draft[actualAction.user.id] = actualAction.user;
            });
        default:
            return currentState;
    }
};
const userIdsByProjectIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case UsersActionType.SET_USERS:
            return produce(currentState, (draft) => {
                const actualAction = action;
                // actualAction.usersDataSet contains the complete User data. However, we only need to save the list of user IDs
                // in draft[actualAction.projectId][actualAction.searchParams]
                const temp = draft[actualAction.projectId] || {};
                draft[actualAction.projectId] = temp;
                temp[actualAction.searchParams] = {
                    range: actualAction.usersDataSet.range,
                    items: actualAction.usersDataSet.items.map((user) => {
                        return user.id;
                    }),
                };
            });
        case UsersActionType.CLEAR_USERS:
            // To clear users, we just need to clear all data for the specified projectId
            return produce(currentState, (draft) => {
                const actualAction = action;
                delete draft[actualAction.projectId];
            });
        default:
            return currentState;
    }
};
export const usersStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.usersById = usersByIdReducer(currentState.usersById, action);
        draft.userIdsByProjectId = castDraft(userIdsByProjectIdReducer(currentState.userIdsByProjectId, action));
    });
};
